<template>
    <div>
        <h2 class="header-hm mt-6 mobile-hidden" v-text="$options.filters['lang']('copy.friends_and_donors')"></h2>
        <div class="desktop-hidden text-center">
            <span class="header-hm mt-6 block" v-text="$options.filters['lang']('copy.meet_and_greet')"></span>
            <span class="header-hm text-orange block" v-text="$options.filters['lang']('copy.out_friends_and_donors')"></span>
        </div>
        <VueSlickCarousel v-bind="settings" class="pt-4">
            <div class="px-4">
                <img class="partner-logo" :src="'/images/l/techsoup.png'" alt="Techsoup Europe"/>
            </div>
            <div class="px-4" v-for="partner in partners">
                <img class="partner-logo" :src="'/storage/partners/' + partner.logo" :alt="partner.name" />
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'Partnerscarousel',
    props: [
        'partners'
    ],
    components: { VueSlickCarousel },
    data() {
        return {
            settings: {
                "arrows": false,
                "focusOnSelect": true,
                "infinite": true,
                "speed": 500,
                "slidesToShow": 4,
                "slidesToScroll": 1,
                "touchThreshold": 5,
                "autoplay": true,
                "autoplaySpeed": 3000,
                "variableWidth": true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            "arrows": false,
                            "edgeFriction": 0.35,
                            "infinite": true,
                            "speed": 500,
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            "autoplay": true,
                            "autoplaySpeed": 2000,
                        }
                    }
               ]
            },
        }
    },
}
</script>

<style scoped>

</style>
